import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { UserService } from '@services/user.service';
import { catchError, Observable, retry, take, throwError } from 'rxjs';
import { SessionStorageService } from './storage.service';

@Injectable({
	providedIn: 'root',
})
export class StylesheetService {
	constructor(
		private httpClient: HttpClient,
		private sessionStorageService: SessionStorageService,
		private userService: UserService,
	) {}

	private getHeaders() {
		const accountId: string = this.userService.account.id;
		const token: string = this.sessionStorageService.get('User.Authorization');
		return new HttpHeaders({
			Authorization: `Bearer ${token}`,
			'x-account-id': accountId,
		});
	}

	private handleError(error: { error: { message: string }; status: any; message: any }) {
		if (error.status === 404) {
			return throwError(() => new Error('Resource not found'));
		}
		let errorMessage = '';
		if (error.error instanceof ErrorEvent) {
			// Get client-side error
			errorMessage = error.error.message;
		} else {
			// Get server-side error
			errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
		}
		if (error.status !== 403) {
			return throwError(() => new Error(errorMessage));
		}
		return [];
	}

	getStylingUrl(httpMethod: string, stylingType: string): Observable<ISignedUrlResult> {
		const engine = this.userService.account.defaultEngine;
		const apiUrl = `${environment.awsEnvUri}/drawing/engines/${engine}/stylings?httpMethod=${httpMethod}&type=${stylingType}`;
		return this.httpClient
			.get<ISignedUrlResult>(apiUrl, {
				headers: this.getHeaders(),
			})
			.pipe(retry(1), catchError(this.handleError));
	}

	uploadStylingFile(fileData, uploadUrl): Observable<any> {
		return this.httpClient.put(uploadUrl, fileData).pipe(take(1));
	}
}

export interface ISignedUrlResult {
	result: ISignedUrlResource;
}

export interface ISignedUrlResource {
	url: string;
	expires: string;
}
